import HubRoutePaginationProvider from '../../providers/HubRoutePaginationProvider.js';
import ListingFiltersConstants from '../constants/filters/listingFiltersConstants';

const hubPaginationProvider = new HubRoutePaginationProvider();

const paginationMixin = {
  data() {
    return {
      paginationData: {
        show: hubPaginationProvider.getPerPage(this.$route),
        page: 1,
        total: 0,
      },
      allowedRoutes: [],
      allowedRouteNames: [],
    };
  },
  mounted() {
    ListingFiltersConstants.forEach((item) => {
      this.allowedRoutes.push(item.path);
      if (item.name) {
        this.allowedRouteNames.push(item.name);
      }
    });
  },
  methods: {
    onPageChange(page) {
      this.updatePaginationQuery(page, this.getShowQueryValue());
      this.paginationData = {
        ...this.paginationData,
        page,
      };
      if (typeof this.index === 'function') {
        this.index();
      }
    },
    elementsPerPageChange(show) {
      this.updatePaginationQuery(this.getPageQueryValue(), show);
      hubPaginationProvider.setPerPage(this.$route, show);

      this.paginationData = {
        ...this.paginationData,
        show,
      };
    },
    preparePaginationUrl(getList = false) {
      const queryString = Object
        .entries(this.preparePaginationParamObject(getList))
        .map((param) => `${ param[0] }=${ param[1] }`)
        .join('&');
      return queryString.length ? `?${ queryString }` : '';
    },
    preparePaginationParamObject(getList = false) {
      let params = {};
      if (getList) {
        params.list = true;
        return params;
      }

      if (this.paginationData.page) {
        params.p = this.getPageQueryValue();
      }
      if (this.paginationData.show) {
        params.s = this.getShowQueryValue();
      }
      this.updatePaginationQuery(params.p, params.s);
      return params;
    },
    updatePaginationQuery(page, show) {
      if (this.isPaginationNotAllowed()) {
        return;
      }
      let filtersObj = {
        ...this.$route.query,
        p: page,
        s: show,
      };
      this.$router.push({
        query: filtersObj,
      }).catch((error) => {});
    },
    getPageQueryValue() {
      if (this.isPaginationNotAllowed()) {
        return this.paginationData.page;
      }
      let query = this.$route.query;

      return !!query.p ? parseInt(query.p) : this.paginationData.page;
    },
    getShowQueryValue(page = null) {
      if (this.isPaginationNotAllowed()) {
        return this.paginationData.show;
      }
      let query = this.$route.query;
      return !!query.s ? parseInt(query.s) : this.paginationData.show;
    },
    isPaginationNotAllowed() {
      return (false === this.allowedRoutes.includes(this.$route.path)) && (false === this.allowedRouteNames.includes(this.$route.name));
    },
  },
};
export default paginationMixin;
